const str = `{HEADER}著作権ポリシー
{BODY_TITLE}
ビデオモンスターのサービスを利用して製作した完成物を再販売する行為は禁じています。「同意して登録完了」をクリックする行為をこの規定への同意とみなします。
ビデオモンスターがよりいいサービスを最低価格で提供できるよう、ご協力お願いいたします。健全なコンテンツ文化を共に作っていきましょう！
`

export default str